import {
    buildSyncWebSocketUrl,
    getWhiteboardSyncUriTemplate,
    toWebSocketUrl,
} from './utils/whiteboardSyncUri';

/** At most one hover-warmup socket, so browsing the list does not leak connections. */
let hoverStop = null;

/**
 * Open the chart's tldraw sync socket so the server can load the room
 * (and canvas snapshot) while the editor JS chunk is still downloading.
 *
 * The socket closes on open so it does not sit as a ghost collaborator; the
 * server keeps the initialized room for the idle grace window.
 *
 * @returns {() => void} close the warmup socket
 */
export function warmupWhiteboardRoom(whiteboardId, sessionId) {
    if (!whiteboardId || !sessionId || typeof WebSocket === 'undefined') {
        return () => {};
    }

    let url;
    try {
        url = toWebSocketUrl(buildSyncWebSocketUrl(
            getWhiteboardSyncUriTemplate(),
            whiteboardId,
            sessionId,
        ));
    } catch {
        return () => {};
    }

    let socket;
    try {
        socket = new WebSocket(url);
    } catch {
        return () => {};
    }

    socket.onerror = () => {};
    // Close as soon as the handshake completes. The server still finishes
    // getOrCreateRoom (snapshot load) and keeps the empty room for the idle
    // grace window — long enough for the editor chunk to mount useSync.
    socket.onopen = () => {
        try {
            socket.close();
        } catch {
            // already closed
        }
    };

    let closed = false;
    return () => {
        if (closed) return;
        closed = true;
        try {
            socket.close();
        } catch {
            // already closed / replaced by the editor session
        }
    };
}

/** List/hover helper: keep only the most recently hovered chart warm. */
export function warmupWhiteboardRoomOnHover(whiteboardId, sessionId) {
    if (hoverStop) {
        hoverStop();
        hoverStop = null;
    }
    hoverStop = warmupWhiteboardRoom(whiteboardId, sessionId);
    return hoverStop;
}

export function stopHoverWhiteboardWarmup() {
    if (!hoverStop) return;
    hoverStop();
    hoverStop = null;
}
